import { createContext, useState, useMemo } from 'react';

export const PromoCodesContext = createContext(null);

export const PromoCodesProvider = ({ children, initialData }) => {
  const [promoCodes, setPromoCodes] = useState(initialData.promoCodes);
  const [excludeList, setExcludeList] = useState(initialData.excludeList)

  const value = useMemo(() => ({
    promoCodes,
    excludeList,
    setPromoCodes,
    setExcludeList
  }), [promoCodes, excludeList]);

  return (
    <PromoCodesContext.Provider value={value}>
      {children}
    </PromoCodesContext.Provider>
  );
};